import React from "react";
import { useEffect, useState, useRef } from "react";
import Select from "react-select";
import {
  IconFileDownload,
} from "@tabler/icons-react";
import toast from "react-hot-toast";
import { donateHistoryApi, getReceiptDonationById, getDonationByIdApi } from "../../../Api/Donation";
import { DonationVerifyApi } from "../../../Api/Donation";
import { getAllBankApi } from "../../../Api/Bank";
import { FaPlus } from "react-icons/fa";
import { VscFilter } from "react-icons/vsc";
import { TbFilterX } from "react-icons/tb";
import * as XLSX from "xlsx";
import { useDonationFilterContext } from "./DonationFilterContext";
import { deleteDonationApi } from "../../../Api/Donation"
import { fetchDonationTypeApi } from "../../../Api/DonationTypes";
import { fetchPurposeApi } from "../../../Api/PurposeType";
import { DonationAnalytics } from "./DonationAnalytics";
import { MdOutlineVerifiedUser } from "react-icons/md";
import DeleteItem from "../DeleteItem";
import { DonationDetailForm } from "./DonationDetailForm";
import SideModal from "../../general/Sidemodal";
import FilterModal from "../../general/Filtermodal";

type Donation = {
  userName: string;
  typeId: number;
  type: string;
  amount: number;
  purposeId: number;
  purpose: string;
  transactionId: string;
  date: Date;
};

interface Options {
  id: string;
  name: string;
}
interface DonationDetailsProps {
  url: string;
  isDarkMode: boolean;
  readyear: string;
}

interface TransactionOption {
  label: string;
  value: string;
}

export const DonationDetails = ({
  url,
  isDarkMode,
  readyear,
}: DonationDetailsProps) => {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [donationHistory, setDonationHistory] = useState<any[]>([]);
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const [filterModal, setfilterModal] = useState(false);
  const [donationtypes, setdonationtypes] = useState<Options[]>([]);
  const [donationpurposes, setdonationpurposes] = useState<Options[]>([]);
  const [years, setyears] = useState<string[]>([]);
  const [months, setmonths] = useState<string[]>([]);
  const [openDropdownId, setOpenDropdownId] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<{ id: string } | null>(null);
  const [banks, setBanks] = useState([]);
  const [donationActiveTab, setDonationActiveTab] = useState<string>("segment-1");
  const [checkreferenceId, setcheckreferenceId] = useState<number | null>(null);
  const [add, setAdd] = useState(false);
  const [editingId, setEditingId] = useState<string | null>(null);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [donationDetails, setDonationDetails] = useState<any | null>(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [detailsError, setDetailsError] = useState<string | null>(null);
  const [unassignedFilter, setUnassignedFilter] = useState<string>('');
  const [downloadingId, setDownloadingId] = useState<string | null>(null);

  const {
    year,
    setyear,
    month,
    setmonth,
    donationtype,
    setdonationtype,
    donationpurpose,
    setdonationpurpose,
    transactionTypes,
    setTransactionTypes,
    ezpayStatus,
    setEzpayStatus,
  } = useDonationFilterContext();

  const toggleDropdown = (id: string) => {
    setOpenDropdownId(openDropdownId === id ? null : id);
  };
  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await getAllBankApi(url);
        const formattedBanks = response.map((bank: any) => ({
          id: bank.id,
          value: bank.id,
          label: `${bank.name} - ${bank.accountNumber}`,
        }));
        setBanks(formattedBanks);
      } catch (error) {
        toast.error(`Error fetching bank data: ${error.message || error}`);
      }
    };

    fetchBanks();
  }, [url]);

  useEffect(() => {
    if (!url) return;
    
    const fetchData = async () => {
      try {
        const response = await fetchDonationTypeApi(url);
        const filteredDonationTypes = response.filter(
          (item: any) => item.parentId !== null
        );
        setdonationtypes(filteredDonationTypes);
        const res = await fetchPurposeApi(url);
        setdonationpurposes(res as Options[]);
        if (!transactionTypes?.some((t: any) => t.value === '1') && ezpayStatus) {
          setEzpayStatus('');
        }
      } catch (error) {
        console.error("Error fetching Data:", error);
      }
    };
    fetchData();
  }, [url, transactionTypes, ezpayStatus, setEzpayStatus]);

  useEffect(() => {
    const startYear = parseInt(readyear);
    const currentYear = new Date().getFullYear();
    const generatedYears = Array.from(
      { length: currentYear - startYear + 1 },
      (_, i) => (startYear + i).toString()
    );
    const generatedMonths = Array.from({ length: 12 }, (_, i) =>
      (i + 1).toString()
    );
    setyears(generatedYears);
    setmonths(generatedMonths);
  }, [readyear]);

  const transactionOptions = [
    { label: "EzPay", number: 1 },
    { label: "Cash", number: 3 },
    { label: "Box", number: 4 },
  ];

  const updatedTransactionOptions: TransactionOption[] = [
    ...[...transactionOptions, ...banks].map(({ label, number, id }) => ({
      label,
      value: (number ?? id).toString(),
    })),
  ];

  const convertTransactionTypesForAPI = (types: any[]) => {
    return types?.map((t) => t.value);
  };

  const handleChange = (selectedOptions: any) => {
    setTransactionTypes(selectedOptions || []);
  };

  const fetchDonationHistory = async (
    url: string,
    transactionTypes?: (string)[],
    donationType?: string,
    purposeType?: string,
    year?: string,
    month?: string,
    search?: string,
    pageNumber?: number,
    pageSize?: number,
    ezpayStatusParam?: string,
    unassignedFilterParam?: string
  ) => {
    try {
      const response = await donateHistoryApi(
        url,
        transactionTypes,
        donationType,
        purposeType,
        year,
        month,
        search,
        pageNumber,
        pageSize,
        ezpayStatusParam,
        unassignedFilterParam
      );
      setDonationHistory(response.donations);
      const totalCount = response.totalCount || 0;
      setTotalPages(Math.ceil(totalCount / ITEMS_PER_PAGE) || 1);
    } catch (error) {
      toast.error("Unable to get Donation History");
      console.error("Error fetching donation history:", error);
    }
  };

  const run = useRef(false);
  useEffect(() => {
    if (run.current) return;
    run.current = true;
    if (!year && !month) {
      fetchDonationHistory(
        url,
        convertTransactionTypesForAPI(transactionTypes),
        donationtype,
        donationpurpose,
        '',
        '', search, currentPage, ITEMS_PER_PAGE, ezpayStatus, unassignedFilter
      );
    } else {
      fetchDonationHistory(
        url,
        convertTransactionTypesForAPI(transactionTypes),
        donationtype,
        donationpurpose,
        year,
        month, search, currentPage, ITEMS_PER_PAGE, ezpayStatus, unassignedFilter
      );

    }
  }, [month, setmonth, setyear, year, url]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (!year && !month) {
        fetchDonationHistory(
          url,
          convertTransactionTypesForAPI(transactionTypes),
          donationtype,
          donationpurpose,
          '',
          '', search, currentPage, ITEMS_PER_PAGE, ezpayStatus, unassignedFilter
        );
      } else {
        fetchDonationHistory(
          url,
          convertTransactionTypesForAPI(transactionTypes),
          donationtype,
          donationpurpose,
          year,
          month, search, currentPage, ITEMS_PER_PAGE, ezpayStatus, unassignedFilter
        );
      }
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [currentPage, search]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      // Check if the click is outside the dropdown and not on the three dots button
      if (!target.closest('.dropdown-container') && !target.closest('[id="menu-button"]')) {
        setOpenDropdownId("");
      }
    };

    // Only add the event listener if a dropdown is open
    if (openDropdownId) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Cleanup function to remove the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openDropdownId]);
  const ITEMS_PER_PAGE = 10;

  const currentdonations = donationHistory;

  const handleDownloadReceipt = async (id: string) => {
    setDownloadingId(id);
    try {
      const pdfBlob = (await getReceiptDonationById(id)) as Blob;
      if (!pdfBlob || pdfBlob.size === 0) {
        toast.error("Receipt is empty or could not be fetched.");
        return;
      }
      const blobUrl = window.URL.createObjectURL(pdfBlob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = `${id}-receipt.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      toast.success("Receipt downloaded successfully.");
    } catch (error) {
      toast.error("Failed to download the receipt.");
    } finally {
      setDownloadingId(null);
    }
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      donationHistory.flatMap((donation) =>
        donation.donationDetails.map((detail: any) => ({
          "Donation ID": donation.id,
          "Transaction Type": donation.transactionType,
          Name: donation.userName,
          Type: detail.donationType,
          Purpose: detail.donationPurpose,
          Amount: donation.amount,
          "Donated On": new Date(donation.donatedOn).toDateString(),
        }))
      )
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Donations");
    XLSX.writeFile(workbook, "DonationHistory.xlsx");
  };

  const handleShowButton = async (index: number, donationId: string) => {
    if (expandedIndex === index) {
      setExpandedIndex(null);
      setDonationDetails(null);
      setDetailsError(null);
      return;
    }
    setExpandedIndex(index);
    setDonationDetails(null);
    setDetailsError(null);
    setDetailsLoading(true);
    try {
      const details = await getDonationByIdApi(donationId, url);
      setDonationDetails(details?.donationDetails || []);
    } catch (error: any) {
      setDetailsError("Failed to fetch donation details");
    } finally {
      setDetailsLoading(false);
    }
  };

  const handleApply = () => {
    setCurrentPage(1);
    fetchDonationHistory(
      url,
      convertTransactionTypesForAPI(transactionTypes),
      donationtype,
      donationpurpose,
      year,
      month,
      search,
      1, // Always start from page 1 when applying filters
      ITEMS_PER_PAGE,
      ezpayStatus,
      unassignedFilter
    );
    setfilterModal(false);
    setExpandedIndex(null);
  };

  const handleDeleteClick = (id: string) => {
    setSelectedItem({ id });
    setIsModalOpen(true);
  };

  const confirmDelete = async () => {
    if (!selectedItem) return;

    try {
      await deleteDonationApi(url, selectedItem.id);
      toast.success("Donation deleted successfully");
      await fetchDonationHistory(url, convertTransactionTypesForAPI(transactionTypes), donationtype, donationpurpose, year, month, search, currentPage, ITEMS_PER_PAGE, ezpayStatus, unassignedFilter);
    } catch (error) {
      toast.error("Error deleting Template:", error);
    } finally {
      setIsModalOpen(false);
      setSelectedItem(null);
    }
  };

  const handleVerifyClick = async (referenceId: number) => {
    try {
      if (!referenceId) {
        toast.error("No referenceId found");
        return;
      }
      setcheckreferenceId(referenceId);
      await DonationVerifyApi(url, referenceId);
      toast.success("Donation verified successfully");
      setcheckreferenceId(null);
      await fetchDonationHistory(url, convertTransactionTypesForAPI(transactionTypes), donationtype, donationpurpose, year, month, search, currentPage, ITEMS_PER_PAGE, ezpayStatus, unassignedFilter);
    } catch (error: any) {
      setcheckreferenceId(null);
      const errorMessage = error?.response?.data?.message || error?.message || "Failed to verify donation";
      console.error("Verify error:", error);
      toast.error(errorMessage);
    }
  };

  const handleEditClick = (id: string) => {
    setEditingId(id);
    setAdd(true)
  };

  return (
    <div
      className={` h-full px-2 md:px-4  ${isDarkMode ? "bg-globalBg" : "bg-[#ffff]"
        }`}
    >
      <div className='flex flex-row items-center '>
        <h2 className="text-3xl font-bold text-blue-600 mb-5 mt-5">
          {donationActiveTab === "segment-1" ? "Donation" : "Donation Analytics"}
        </h2>
        {donationActiveTab === "segment-1" &&
          <button
            type="button"
            className=" w-fit px-3 py-2 mx-3 tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
            onClick={() => {
              setEditingId(null);
              setAdd(true);
            }}
          >
            <FaPlus className="w-3 h-3" />
          </button>
        }

      </div>
      <div>
        {/* Tabs Navigation */}
        <div className="flex overflow-x-auto whitespace-nowrap border-b border-gray-300 dark:border-gray-500">
          <button

            className={`inline-flex items-center h-12 px-4 py-2 text-center text-gray-700 border border-b-0 border-gray-300 dark:border-gray-500 rounded-t-md focus:outline-none whitespace-nowrap transition-all 
         ${donationActiveTab === "segment-1" ? "bg-blue-500 dark:bg-blue-700 text-white border-gray-400 dark:border-gray-300" : "bg-transparent text-gray-500 hover:border-gray-400 dark:hover:border-gray-300"}`}
            onClick={() => setDonationActiveTab("segment-1")}

          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-database-dollar"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3" /><path d="M4 6v6c0 1.657 3.582 3 8 3c.415 0 .822 -.012 1.22 -.035" /><path d="M20 10v-4" /><path d="M4 12v6c0 1.657 3.582 3 8 3c.352 0 .698 -.009 1.037 -.025" /><path d="M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5" /><path d="M19 21v1m0 -8v1" /></svg>
            <span className="mx-1 text-sm sm:text-base">Details</span>
          </button>

          <button
            className={`inline-flex items-center h-12 px-4 py-2 text-center text-gray-700 border border-b-0 border-gray-300 dark:border-gray-500 rounded-t-md  focus:outline-none whitespace-nowrap transition-all 
        ${donationActiveTab === "segment-2" ? "bg-blue-500 dark:bg-blue-700 text-white border-gray-400 dark:border-gray-300" : "bg-transparent text-gray-500 hover:border-gray-400 dark:hover:border-gray-300"}`}
            onClick={() => setDonationActiveTab("segment-2")}
          >

            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-report-analytics"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" /><path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" /><path d="M9 17v-5" /><path d="M12 17v-1" /><path d="M15 17v-3" /></svg>
            <span className="mx-1 text-sm sm:text-base">Analytics</span>
          </button>
        </div>
        {/* Tab Content */}
        <div className="mt-3">
          {donationActiveTab === "segment-1" && (
            <div id="segment-2" role="tabpanel">
              <div className=" flex flex-row gap-2 w-full mt-10   ">
                <div className="mb-4 w-full">
                  <input
                    type="text"
                    placeholder="Search Name,email,mobile,amount"
                    className={`w-full p-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-500 ${isDarkMode
                      ? "bg-[#2e2e2e] border-gray-700 text-white"
                      : "border-gray-300"
                      }`}
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
                <div
                  className="flex flex-row gap-1  justify-center px-1 py-2 h-10 w-[90px] hover:bg-gray-100 rounded-md cursor-pointer"
                  onClick={() => setfilterModal(true)}
                >
                  <VscFilter className="text-blue-500 h-7 w-7 " />
                  <span className="text-lg font-normal text-gray-600">Filter</span>
                </div>
              </div>
              {/* Table */}
              <div className="border border-gray-200 dark:border-gray-700 md:rounded-lg mt-5">
                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                  <thead className="bg-gray-50 dark:bg-gray-800">
                    <tr>
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                      >
                        Actions
                      </th>
                      <th
                        scope="col"
                        className={`px-4 py-3.5 text-md font-normal text-left rtl:text-right ${isDarkMode ? " text-gray-500" : " text-gray-500"
                          }`}
                      >
                        <span>Reference ID</span>
                      </th>
                      <th
                        scope="col"
                        className={`px-4 py-3.5 text-md font-normal text-left rtl:text-right ${isDarkMode ? " text-gray-500" : " text-gray-500"
                          }`}
                      >
                        <span>Name</span>
                      </th>
                      <th
                        scope="col"
                        className={`px-4 py-3.5 text-md font-normal text-left rtl:text-right ${isDarkMode ? " text-gray-500" : " text-gray-500"
                          }`}
                      >
                        <span>Email</span>
                      </th>
                      <th
                        scope="col"
                        className={`px-4 py-3.5 text-md font-normal text-left rtl:text-right ${isDarkMode ? " text-gray-500" : " text-gray-500"
                          }`}
                      >
                        <span>Mobile No</span>
                      </th>
                      <th
                        scope="col"
                        className={`px-4 py-3.5 text-md font-normal text-left rtl:text-right ${isDarkMode ? " text-gray-500" : " text-gray-500"
                          }`}
                      >
                        <span> Amount</span>
                      </th>
                      <th
                        scope="col"
                        className={`px-4 py-3.5 text-md font-normal text-left rtl:text-right ${isDarkMode ? " text-gray-500" : " text-gray-500"
                          }`}
                      >
                        <span>Donated On</span>
                      </th>
                      <th
                        scope="col"
                        className={`px-4 py-3.5 text-md font-normal text-left rtl:text-right ${isDarkMode ? " text-gray-500" : " text-gray-500"
                          }`}
                      >
                        Type
                      </th>
                      <th
                        scope="col"
                        className={`px-4 py-3.5 text-md font-normal text-left rtl:text-right ${isDarkMode ? " text-gray-500" : " text-gray-500"
                          }`}
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        className={`px-4 py-3.5 text-md font-normal text-left rtl:text-right ${isDarkMode ? " text-gray-500" : " text-gray-500"
                          }`}
                      >
                        View Details
                      </th>
                      <th
                        scope="col"
                        className={`px-4 py-3.5 text-md font-normal text-left rtl:text-right ${isDarkMode ? " text-gray-500" : " text-gray-500"
                          }`}
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <div></div>
                  <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-900">
                    {currentdonations.length > 0
                      ? currentdonations.map((donation: any, index: any) => (
                        <React.Fragment key={index}>
                          <tr>
                            <td className="px-4 py-4 text-sm whitespace-nowrap flex felx-row gap-2">
                              <div className="text-left relative dropdown-container">
                                <div>
                                  <button
                                    type="button"
                                    className="p-2 rounded-md hover:bg-gray-100"
                                    onClick={(e) => {
                                      toggleDropdown(donation.id);
                                    }}
                                    id="menu-button"
                                    aria-expanded={openDropdownId === donation.id}
                                    aria-haspopup="true"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="w-3 h-5"
                                      viewBox="0 0 448 512"
                                    >
                                      <path d="M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z" />
                                    </svg>
                                  </button>
                                </div>
                                {openDropdownId === donation.id && (
                                  <div
                                    className="absolute w-56 origin-top-right rounded-md bg-white ring-1 shadow-lg ring-black/5 focus:outline-hidden z-10"
                                    role="menu"
                                    aria-orientation="vertical"
                                    aria-labelledby="menu-button"
                                  >
                                    <div className="py-1" role="none">

                                      {(donation.transactionType === 1 && donation.status != "E000" && donation.status != "Success") && (
                                        <div className="px-3">
                                          <button
                                            onClick={() => handleVerifyClick(donation.referenceId)}
                                            className="text-gray-500 transition-colors duration-200 dark:hover:text-yellow-500 dark:text-gray-300 hover:text-yellow-500 focus:outline-none flex items-center"
                                          >
                                            <MdOutlineVerifiedUser />
                                            <span
                                              className="block px-4 py-2 text-sm text-gray-700"
                                            >
                                              Verify
                                            </span>
                                          </button>
                                        </div>
                                      )}
                                      <div className="px-3">
                                        {/* edit */}
                                        <button
                                          onClick={() => handleEditClick(donation.id)}
                                          className="text-gray-500 transition-colors duration-200 dark:hover:text-yellow-500 dark:text-gray-300 hover:text-yellow-500 focus:outline-none flex items-center"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke-width="1.5"
                                            stroke="currentColor"
                                            className="w-5 h-5"
                                          >
                                            <path
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                                            />
                                          </svg>
                                          <span
                                            className="block px-4 py-2 text-sm text-gray-700"
                                          >
                                            Edit
                                          </span>
                                        </button>
                                      </div>

                                      {(donation.status !== "E000" && donation.status !== "Success" && donation.status !== "E006") && (
                                        <div className="px-3">
                                          {/* delete */}
                                          <button
                                            onClick={() => handleDeleteClick(donation.id)}
                                            className="text-gray-500 transition-colors duration-200 dark:hover:text-red-600 dark:text-gray-300 hover:text-red-500 focus:outline-none flex items-center"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              viewBox="0 0 24 24"
                                              stroke-width="1.5"
                                              stroke="currentColor"
                                              className="w-5 h-5"
                                            >
                                              <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                                              />
                                            </svg>
                                            <span
                                              className="block px-4 py-2 text-sm text-gray-700"
                                            >
                                              Delete
                                            </span>
                                          </button>
                                        </div>
                                      )}

                                    </div>
                                  </div>
                                )}
                              </div>
                            </td>
                            <td
                              className={`px-4 py-4 text-sm font-medium ${isDarkMode ? " text-gray-500" : " text-gray-500"
                                }`}
                            >
                              {" "}
                              {donation.referenceId}
                            </td>
                            <td
                              className={`px-4 py-4 text-sm font-medium ${isDarkMode ? " text-gray-500" : " text-gray-500"
                                }`}
                            >
                              {" "}
                              {donation.userName}
                            </td>
                            <td
                              className={`px-4 py-4 text-sm   ${isDarkMode ? " text-gray-500" : " text-gray-500"
                                }`}
                            >
                              {donation.email}
                            </td>
                            <td
                              className={`px-4 py-4 text-sm   ${isDarkMode ? " text-gray-500" : " text-gray-500"
                                }`}
                            >
                              {donation.mobile}
                            </td>
                            <td
                              className={`px-4 py-4 text-sm   ${isDarkMode ? " text-gray-500" : " text-gray-500"
                                }`}
                            >
                              {donation.amount}
                            </td>
                            <td
                              className={`px-4 py-4 text-sm  ${isDarkMode ? " text-gray-500" : " text-gray-500"
                                }`}
                            >
                              {new Date(donation.donatedOn)
                                .toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                })
                                .replace(/\//g, "/")}
                            </td>
                            <td

                              className={`px-4 py-4 text-sm  ${isDarkMode ? " text-gray-500" : " text-gray-500"
                                }`}
                            >
                              {donation.transactionType === 1
                                ? "Ezpay"
                                : donation.transactionType === 3
                                  ? "Cash"
                                  : donation.transactionType === 4
                                    ? "Box"
                                    : donation.transactionType === 2
                                      ? `${donation.bankName}-${donation.accountNo}`
                                      : donation.transactionType === null
                                        ? "Null"
                                        : ""}

                            </td>
                            <td className={`px-4 py-4 text-sm ${isDarkMode ? "text-gray-500" : "text-gray-500"}`}>
                              {donation.status ? (
                                donation.status
                              ) : checkreferenceId === donation.referenceId ? (
                                <div className="w-7 h-7 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin-20s"
                                ></div>
                              ) : (
                                <button
                                  className="bg-blue-400 text-white px-4 py-1 rounded-sm hover:bg-blue-600"
                                  onClick={() => handleVerifyClick(donation.referenceId)}
                                >
                                  Verify
                                </button>
                              )}
                            </td>
                            <td
                              className={`px-4 py-4 text-sm   ${isDarkMode ? " text-gray-500" : " text-gray-500"
                                }`}
                            >
                              <button
                                className="text-blue-600 hover:underline"
                                onClick={() => handleShowButton(index, donation.id)}
                              >
                                {expandedIndex === index ? "Hide" : "Show"}
                              </button>
                            </td>
                            <td className="px-4 py-4 text-sm font-medium text-gray-700 whitespace-nowrap">
                              <button
                                className={` px-3 py-1 rounded flex items-center ${downloadingId === donation.id ? 'cursor-not-allowed opacity-70  text-gray-500' : 'text-blue-500 hover:text-blue-700'}`}
                                onClick={() => handleDownloadReceipt(donation.id)}
                                disabled={downloadingId === donation.id}
                              >
                                {downloadingId === donation.id ? (
                                  <span className="w-5 h-5  border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></span>
                                ) : (
                                  <IconFileDownload size={30} className="mr-2" />
                                )}
                              </button>
                            </td>
                          </tr>
                          {expandedIndex === index && (
                            <tr>
                              <td colSpan={7} className=" px-4 py-2">
                                <div>
                                  {detailsLoading ? (
                                    <div className="text-center py-4">Loading details...</div>
                                  ) : detailsError ? (
                                    <div className="text-center text-red-500 py-4">{detailsError}</div>
                                  ) : (
                                    <table className="w-full border-collapse border border-gray-200">
                                      <thead className="bg-gray-200">
                                        <tr>
                                          <th className="font-normal px-4 py-2 text-center text-gray-500">
                                            Purpose
                                          </th>
                                          <th className="font-normal px-4 py-2 text-center text-gray-500">
                                            Type
                                          </th>
                                          <th className="font-normal px-4 py-2 text-center text-gray-500">
                                            Amount
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {donationDetails && donationDetails.length > 0 ? (
                                          donationDetails.map((detail: any, detailIndex: number) => (
                                            <tr
                                              key={detailIndex}
                                              className="hover:bg-gray-50"
                                            >
                                              <td className="border border-gray-300 px-4 py-2 text-center text-gray-500">
                                                {detail.donationPurpose || "Not Specified"}
                                              </td>
                                              <td className="border border-gray-300 px-4 py-2 text-center text-gray-500">
                                                {detail.donationType || "Not Specified"}
                                              </td>
                                              <td className="border border-gray-300 px-4 py-2 text-center text-gray-500  ">
                                                {detail.amount}
                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan={3} className="text-center text-gray-400 py-4">No details found.</td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  )}
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))
                      : <tr>
                        <td colSpan={11} className="px-4 py-4 text-center">
                          No donations found
                        </td>
                      </tr>}
                  </tbody>
                </table>
              </div>
              <div className="flex space-x-4 mt-4">

                <SideModal isOpen={add} onClose={() => setAdd(false)}>
                  <DonationDetailForm
                    url={url}
                    setAdd={setAdd}
                    Id={editingId}
                    onSuccess={() => fetchDonationHistory(url, convertTransactionTypesForAPI(transactionTypes), donationtype, donationpurpose, year, month, search, currentPage, ITEMS_PER_PAGE, ezpayStatus, unassignedFilter)}
                  />
                </SideModal>


                <button
                  onClick={handleDownloadExcel}
                  className=" font-medium bg-blue-600 hover:bg-blue-500 text-white focus:ring-blue-300 focus:ring-opacity-80 px-4 py-2 rounded-md flex items-center"
                >
                  <IconFileDownload className="mr-2" />
                  Download
                </button>
              </div>
              {/* Pagination */}
              <div className="flex items-center justify-between mt-6">
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                  className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="w-5 h-5 rtl:-scale-x-100"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
                    />
                  </svg>
                  <span>Previous</span>
                </button>

                <div className="items-center hidden lg:flex gap-x-3">
                  {Array.from({ length: Math.min(10, totalPages) }, (_, index) => {
                    const startPage = Math.max(1, currentPage - 5);
                    const page = startPage + index;

                    if (page > totalPages) return null;

                    return (
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        className={`px-2 py-1 text-sm ${currentPage === page
                          ? "text-blue-500 bg-blue-100"
                          : "text-gray-500 hover:bg-gray-100"
                          } rounded-md`}
                      >
                        {page}
                      </button>
                    );
                  })}
                </div>

                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                  className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <span>Next</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="w-5 h-5 rtl:-scale-x-100"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                    />
                  </svg>
                </button>
              </div>
              {/* {filterModal} */}
              <FilterModal isOpen={filterModal} onClose={() => setfilterModal(false)}>
                <div className="px-4 relative  mx-auto">
                  <h2 className="text-2xl font-bold text-blue-700 mt-4 mb-2 text-center">Donation History Filters</h2>
                  <div className="flex items-center gap-4 mt-4 mb-2">
                    <div
                      onClick={() => {
                        setyear('');
                        setmonth('');
                        setdonationtype('');
                        setdonationpurpose('');
                        setTransactionTypes([]);
                        setEzpayStatus('');
                        setUnassignedFilter('');
                        setSearch('');
                        setCurrentPage(1);
                        setfilterModal(false);
                        setExpandedIndex(null);
                        fetchDonationHistory(url, [], '', '', '', '', '', 1, ITEMS_PER_PAGE, '', '');
                      }}
                      className="cursor-pointer flex items-center gap-2 hover:bg-gray-200 px-2 py-1 rounded-md border border-gray-200 shadow-sm"
                    >
                      <TbFilterX className="text-blue-500 h-5 w-5" />
                      <span className="text-sm font-medium">Clear all</span>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 gap-6 mt-6">
                    <div>
                      <label className="block text-base font-semibold text-gray-900 mb-1">Transaction By</label>
                      <Select
                        isMulti
                        value={transactionTypes}
                        onChange={handleChange}
                        options={updatedTransactionOptions}
                        className="w-full"
                        placeholder="Select Transaction By"
                        isClearable
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            borderColor: state.isFocused
                              ? "rgb(96 165 250)"
                              : "rgb(31 41 55)",
                            borderRadius: "0.180rem",
                            boxShadow: state.isFocused
                              ? "0 0 0 1px rgb(96 165 250)"
                              : "none",
                          }),
                          placeholder: (base) => ({
                            ...base,
                            color: "rgb(31 41 55)",
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isFocused ? "rgb(37 99 235)" : "white",
                            color: state.isFocused ? "white" : "black",
                            cursor: "pointer",
                            height: "30px",
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "10px",
                          }),
                          dropdownIndicator: (base) => ({
                            ...base,
                            color: "rgb(31 41 55)",
                            ":hover": { color: "rgb(55 65 81)" },
                            svg: {
                              strokeWidth: "1",
                              width: "14px",
                              height: "14px",
                            },
                          }),
                          indicatorSeparator: () => null,
                        }}
                      />
                    </div>

                    {transactionTypes?.some((t: any) => t.value === '1') && (
                      <div>
                        <label className="block text-base font-semibold text-gray-900 mb-1">Status</label>
                        <select
                          id="ezpayStatus"
                          value={ezpayStatus}
                          onChange={(e) => setEzpayStatus(e.target.value)}
                          className="w-full p-2 text-base text-gray-700 bg-white border border-gray-300 rounded-md focus:outline-none focus:border-blue-400"
                        >
                          <option value="">All</option>
                          <option value="Success">Success</option>
                          <option value="InProgress">InProgress</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    )}

                    <div>
                      <label className="block text-base font-semibold text-gray-900 mb-1">Unassigned Donations</label>
                      <select
                        id="unassignedFilter"
                        value={unassignedFilter}
                        onChange={(e) => setUnassignedFilter(e.target.value)}
                        className="w-full p-2 text-base text-gray-700 bg-white border border-gray-300 rounded-md focus:outline-none focus:border-blue-400"
                      >
                        <option value="">Select</option>
                        <option value="unassigned">Unassigned</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-base font-semibold text-gray-900 mb-1">Donation Type</label>
                      <select
                        id="donationType"
                        required
                        value={donationtype}
                        onChange={(e) => setdonationtype(e.target.value)}
                        className="w-full p-2 text-base text-gray-700 bg-white border border-gray-300 rounded-md focus:outline-none focus:border-blue-400"
                      >
                        <option value="">Select Donation Type</option>
                        {donationtypes.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-base font-semibold text-gray-900 mb-1">Donation Purpose</label>
                      <select
                        id="donationPurpose"
                        required
                        value={donationpurpose}
                        onChange={(e) => setdonationpurpose(e.target.value)}
                        className="w-full p-2 text-base text-gray-700 bg-white border border-gray-300 rounded-md focus:outline-none focus:border-blue-400"
                      >
                        <option value="">Select Donation Purpose</option>
                        {donationpurposes.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="flex gap-4">
                      <div className="flex-1">
                        <label className="block text-base font-semibold text-gray-900 mb-1">Year</label>
                        <select
                          value={year}
                          onChange={(e) => {
                            setyear(e.target.value);
                            if (!e.target.value) {
                              setmonth("");
                            }
                          }}
                          className="w-full p-2 text-base text-gray-700 bg-white border border-gray-300 rounded-md focus:outline-none focus:border-blue-400"
                        >
                          <option value="">Select Year</option>
                          {years.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="flex-1">
                        <label className="block text-base font-semibold text-gray-900 mb-1">Month</label>
                        <select
                          value={month}
                          onChange={(e) => setmonth(e.target.value)}
                          className="w-full p-2 text-base text-gray-700 bg-white border border-gray-300 rounded-md focus:outline-none focus:border-blue-400"
                          disabled={!year}
                        >
                          <option value="">Select Month</option>
                          {months.map((month) => (
                            <option key={month} value={month}>
                              {month}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                  </div>
                  <div className="flex gap-x-2">
                    <div className="flex gap-4 mt-8 justify-end">
                      <button
                        className="px-6 py-2 text-white border border-blue-700 rounded-md bg-blue-600 hover:bg-blue-700 font-semibold shadow"
                        onClick={handleApply}
                      >
                        Apply
                      </button>
                    </div>

                    <div className="flex gap-4 mt-8 justify-end">
                      <button
                        className="px-6 py-2 text-white border border-blue-700 rounded-md bg-blue-600 hover:bg-blue-700 font-semibold shadow"
                        onClick={() => setfilterModal(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>

                </div>
              </FilterModal>
            </div>
          )}
          {donationActiveTab === "segment-2" && (
            <div id="segment-1" role="tabpanel">
              <DonationAnalytics
                isDarkMode={isDarkMode}
                url={url}
                readyear={readyear}
                donationtypes={donationtypes}
                donationpurposes={donationpurposes}
              />
            </div>
          )}
        </div>
      </div>
      {isModalOpen && (
        <DeleteItem onClose={() => setIsModalOpen(false)} onConfirm={confirmDelete} />
      )}
    </div>
  );
};
